import { FC } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import {
  CHART_SHADOW,
  CUSTOM_REVENUE_TOOLTIP,
  GBP_SYMBOL,
} from "lib/constants";

interface RoomRevenueChartProps {
  data: RoomRevenueEntry[];
  width?: string | number;
  height?: string | number;
  className?: string;
}

const RoomRevenueChart: FC<RoomRevenueChartProps> = ({
  data,
  width = "100%",
  height = "100%",
  className,
}) => {
  const xAxisCategories = data.map((entry) => `Room-${entry.roomNumber}`);
  const revenueData = data.map((entry) => entry.cost);
  const yAxisMax = Math.max(...revenueData) * 1.1;

  const series = [
    {
      name: "Room Revenue",
      data: revenueData,
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: { enabled: false },
      dropShadow: CHART_SHADOW,
    },
    xaxis: {
      categories: xAxisCategories,
      title: { text: "Room Number" },
      labels: {
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      max: yAxisMax,
      min: 0,
      title: { text: "Revenue (GBP)" },
      labels: {
        formatter: (val) => `${GBP_SYMBOL}${val}`,
      },
    },
    tooltip: {
      custom: CUSTOM_REVENUE_TOOLTIP,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    markers: {
      size: 4,
      hover: { size: 5 },
      colors: ["#fff"],
      strokeColors: "black",
      strokeWidth: 2,
    },
    colors: ["black"],
    grid: {
      borderColor: "#e0e0e0",
      strokeDashArray: 4,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: "top",
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="line"
      width={width}
      height={height}
      className={className}
    />
  );
};

export default RoomRevenueChart;
